export async function initCharts() {
    if ((window as any).Chart === undefined) {

        // eslint-disable-next-line @typescript-eslint/promise-function-async
        const loadScript = (src: string) => {
            return new Promise<void>((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => resolve();
                script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
                document.head.appendChild(script);
            });
        };

        try {
            await loadScript('https://cdn.jsdelivr.net/npm/chart.js');

            await loadScript('https://cdn.jsdelivr.net/npm/chart.js/dist/chart.min.js');

            await loadScript('https://cdn.jsdelivr.net/npm/chartjs-adapter-date-fns/dist/chartjs-adapter-date-fns.bundle.min.js');

            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    } else {
        return true;
    }
}